import React from "react";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";

export const AttritionRateCallout = () => {
  const { tooltip, title, current } = useSelector((state) => state.studioInfo.attritionRate.data);

  return (
    <>
      <div className="callout" data-tip={tooltip} data-for={title}>
        <p>{title}</p>
        <p className="callout-value">{(current * 100).toFixed(2)}%</p>
      </div>
      <ReactTooltip id={title} html />
    </>
  );
};
